const SITE_CONFIGS = {
    vax: {vaccineType: '流感', productionOrigin: 'https://vaxchat.cn'},
    hpv: {vaccineType: 'HPV', productionOrigin: 'https://hpv.vaxchat.cn'},
    rsv: {vaccineType: 'RSV', productionOrigin: 'https://rsv.vaxchat.cn'},
    cancer: {vaccineType: 'CRC', productionOrigin: 'https://cancerchat.cn'}
};

const normalizeHostname = (hostname) => String(hostname || '')
    .trim()
    .toLowerCase()
    .replace(/\.$/, '');

export const getSiteTypeFromHostname = () => {
    if (typeof window === 'undefined') return 'vax';

    const hostname = normalizeHostname(window.location.hostname);
    if (hostname === 'rsv.vaxchat.cn' || hostname.startsWith('rsv.')) return 'rsv';
    if (hostname === 'hpv.vaxchat.cn' || hostname.startsWith('hpv.')) return 'hpv';
    if (
        hostname === 'cancerchat.cn' ||
        hostname === 'www.cancerchat.cn' ||
        hostname.startsWith('cancer.')
    ) return 'cancer';
    return 'vax';
};

export const getVaccineTypeFromHostname = () => (
    SITE_CONFIGS[getSiteTypeFromHostname()].vaccineType
);

const getLocalApiHostOverride = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    const hostname = normalizeHostname(window.location.hostname);
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' ||
        hostname === '0.0.0.0' || hostname.endsWith('.localhost');
    if (!isLocal) {
        return null;
    }

    const apiHost = new URLSearchParams(window.location.search).get('apiHost');
    if (!apiHost) {
        return null;
    }

    try {
        const parsed = new URL(apiHost);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
            return parsed.origin;
        }
    } catch (error) {
        console.warn('Invalid apiHost override:', apiHost);
    }
    return null;
};

export const getHostIP = () => {
    const localApiHost = getLocalApiHostOverride();
    if (localApiHost) return localApiHost;
    if (typeof window !== 'undefined' && window.location.origin) {
        return window.location.origin;
    }
    return SITE_CONFIGS.vax.productionOrigin;
};

export default SITE_CONFIGS.vax.productionOrigin;
